/* eslint-disable import/first */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import { initializeTelemetry } from './telemetry.js'
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueMq from 'vue-mq'
import { store } from './store'

// Import the SideNav
import 'shipbob_design_system/webcomponents'

// Import the Design System
import DesignSystem from 'shipbob-design-system'

// PrimeVue Style Injection
import { primeVueStyleInjection } from './components/micro-front-ends/utils/PrimeVueStyleInjection.js'

import('shipbob-design-system/dist/svgs/svgs.js')

// Plugins
import SbTogglePlugin from './plugins/toggle-plugin'
import PaginationPlugin from './plugins/pagination-plugin'
import LoadingSpinnerPlugin from './plugins/loading-spinner-plugin'
import LoadingOverlayPlugin from './plugins/loading-overlay-plugin'
import DropdownPlugin from './plugins/dropdown-plugin'
import InputPlugin from './plugins/input-plugin'
import LayoutsPlugin from './plugins/layouts-plugin'
import SBTable from './plugins/sb-table-plugin'
import FormInput from './plugins/form-input-plugin'
import SBRadioButtons from './plugins/radio-buttons-plugin'
import SbCheckboxOld from './plugins/sb-checkbox-plugin'
import FileUploadLinkPlugin from './plugins/file-upload-link-plugin'
import SbTextArea from './plugins/sb-textarea-plugin'
import CustomTransitions from './plugins/custom-transitions-plugin'
import CustomDirectives from './plugins/custom-directives-plugin'
import CustomFilters from './plugins/custom-filters-plugin'
import FunctionalWrapperComponentsPlugin from './plugins/functional-wrapper-plugin'
import VueCookies from 'vue-cookies'
import HelpCenterLinksPlugin from './plugins/help-center-links-plugin'
import AppSettingsPlugin from './plugins/app-settings-plugin'
import DrawerWrapperPlugin from './plugins/drawer-wrapper-plugin'
import i18n from './i18n'

Vue.use(VueAxios, axios)
Vue.use(SbTogglePlugin)
Vue.use(PaginationPlugin)
Vue.use(LoadingSpinnerPlugin)
Vue.use(LoadingOverlayPlugin)
Vue.use(DropdownPlugin)
Vue.use(InputPlugin)
Vue.use(LayoutsPlugin)
Vue.use(SBTable)
Vue.use(FormInput)
Vue.use(SBRadioButtons)
Vue.use(SbCheckboxOld)
Vue.use(FileUploadLinkPlugin)
Vue.use(SbTextArea)
Vue.use(CustomTransitions)
Vue.use(CustomDirectives)
Vue.use(CustomFilters)
Vue.use(FunctionalWrapperComponentsPlugin)
Vue.use(HelpCenterLinksPlugin)
Vue.use(AppSettingsPlugin)
Vue.use(DrawerWrapperPlugin)
Vue.use(VueCookies)
Vue.use(VueMq, {
  breakpoints: { // set breakpoints
    xs: 0,
    sm: 576,
    md: 768,
    lg: 1024,
    xl: 1366,
    xxl: Infinity
  }
})
Vue.use(DesignSystem)

// -------------------
Vue.prototype.$shipBobStore = store

initializeTelemetry(store)
primeVueStyleInjection.start()

Vue.config.productionTip = false
window.onload = ev => {
  try { Typekit.load({ async: true }) } catch (e) { console.warn(`failed to load Typekit`) } // eslint-disable-line
}

// eslint-disable-next-line no-new
new Vue({
  el: '#shipbobVueApp2',
  router,
  components: { App },
  template: '<App/>',
  i18n
})
